export default "__VITE_PUBLIC_ASSET__99310b01__"